export function getAuthorshipUserAccessor(
  accessorKey: string
): 'createdByUser' | 'updatedByUser' | null {
  if (accessorKey === 'createdBy') return 'createdByUser'
  if (accessorKey === 'updatedBy') return 'updatedByUser'
  return null
}
